<template>
<div>
    <el-upload ref="upload" action="/" :show-file-list="false" :on-change="importFile" :auto-upload="false" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
        <el-button slot="trigger" icon="el-icon-upload" size="small" type="primary">上传文件</el-button>
    </el-upload>

    <el-dialog :visible.sync="meterConfigDialogVisible" width="116rem" top="15vh" size="small">
        <template slot="title">
            配置仪表
        </template>
        <div style="max-height: 32rem; overflow: auto">
            <el-table class="customerUsers-table" size="small" :data="meterConfigInfos" style="width: 100%" border stripe height="32rem" :span-method="objectSpanMethod">
                <el-table-column type="index" width="50" fixed></el-table-column>
                <el-table-column prop="customerName" align="center" width="100" fixed label="客户名称"></el-table-column>
                <el-table-column prop="customerCode" align="center" width="100" fixed label="客户编码"></el-table-column>
                <el-table-column prop="customerUserName" align="center" width="100" fixed label="业主用户名称"></el-table-column>
                <el-table-column prop="customerUserCode" align="center" width="100" fixed label="业主用户编码"></el-table-column>
                <el-table-column prop="meterName" align="center" width="100" fixed label="仪表名称"></el-table-column>
                <el-table-column prop="meterCode" align="center" width="250" fixed label="仪表编码"></el-table-column>
                <el-table-column prop="meterType" align="center" width="120" label="仪表类型">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.isEdit" v-model="scope.row.meterType" placeholder="请选择" size="mini">
                            <el-option v-for="(meterType,index) in meterTypes" :key="index" :label="meterType.code" :value="meterType.id"></el-option>
                        </el-select>
                        <span v-if="!scope.row.isEdit">{{scope.row.meterType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="energyType" align="center" width="100" label="能源类型">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.isEdit" v-model="scope.energyType" placeholder="请选择" size="mini">
                            <el-option label="电" :value="0"></el-option>
                            <el-option label="水" :value="1"></el-option>
                        </el-select>
                        <span v-if="!scope.row.isEdit">{{scope.row.energyType === 0 ? '电' : '水'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isCutoutOfArrear" align="center" width="100" label="使能欠费跳闸">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.isEdit" v-model="scope.isCutoutOfArrear" placeholder="请选择" size="mini" :disabled="scope.meterType === 'shui' || scope.meterType === 'dian'">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                        <span v-if="!scope.row.isEdit">{{scope.row.isCutoutOfArrear === 0 ? '否' : '是'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="priceCode" align="center" width="120" label="计费价格">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.isEdit" v-model="scope.row.priceCode" placeholder="请选择" size="mini">
                            <el-option v-for="(chargePrice,index) in chargePrices" :key="index" :label="chargePrice.name" :value="chargePrice.id"></el-option>
                        </el-select>
                        <span v-if="!scope.row.isEdit">{{scope.row.priceName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="alarmMoney" align="center" width="120" label="预警金额(元)">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.alarmMoney" size="mini" placeholder="请输入预警金额" @change=""><template slot="suffix">元</template></el-input>
                        <span v-if="!scope.row.isEdit">{{scope.row.alarmMoney}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="overdraftMoney" align="center" width="120" label="透支金额(元)">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.overdraftMoney" size="mini" placeholder="请输入透支金额" @change=""><template slot="suffix">元</template></el-input>
                        <span v-if="!scope.row.isEdit">{{scope.row.overdraftMoney}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="hoardMoney" align="center" width="120" label="囤积金额(元)">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.hoardMoney" size="mini" placeholder="请输入囤积金额" @change=""><template slot="suffix">元</template></el-input>
                        <span v-if="!scope.row.isEdit">{{scope.row.hoardMoney}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="210">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary " @click="rowEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="success" @click="rowSave(scope.$index, scope.row)">保存</el-button>
                        <el-button size="mini" type="danger" @click="rowDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="meterConfigDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="" size="small">保存</el-button>
            </span>
    </el-dialog>

</div>

</template>

<script>
  import XLSX from "xlsx"
  import { getChargingByCustomerId } from "@/api/ChargingPrice"
  import { amountRegex } from '@/utils/validate'

  export default {
    data() {
      var validateAlarmAmount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('预警金额必填'))
        } else {
          if(!amountRegex.test(value)){
            callback(new Error("请输入正确的金额"))
          }else {
            if (this.meterConfigInfo.hoardMoney === '') {
              callback(new Error('囤积金额必填'))
            } else {
              if (parseFloat(value) > parseFloat(this.meterConfigInfo.hoardMoney)) {
                callback(new Error('预警金额不能大于可囤积金额'))
              } else {
                callback()
              }
            }
          }
        }
      }
      var validateOverdraftAmount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('透支金额必填'))
        } else {
          if(!amountRegex.test(value)){
            callback(new Error("请输入正确的金额"))
          }else{
            if (this.meterConfigInfo.hoardMoney === '') {
              callback(new Error('囤积金额必填'))
            }else{
              if(parseFloat(value) > parseFloat(this.meterConfigInfo.hoardMoney)){
                callback(new Error('透支金额不能大于可囤积金额'))
              }else{
                callback()
              }
            }
          }
        }
      }
      return {
        meterConfigInfoArr: {},
        meterConfigInfos: [],
        chargingPrices: [],
        meterConfigDialogVisible: false,
        meterConfigRules: {
          /*chargingPriceId: [{ required: true, message: '当前计费价格必选', trigger: 'change' }],*/
          //nextChargingPriceId: [{ required: true, message: '预制计费价格必选', trigger: 'change' }],
          alarmMoney: [{ validator: validateAlarmAmount, trigger: 'blur' },{ required: true, message: '预警金额必填', trigger: 'blur' }/*{ pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }*/],
          overdraftMoney: [{ validator: validateOverdraftAmount, trigger: 'blur' },{ required: true, message: '可透支金额必填', trigger: 'blur' }/*{ pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }*/],
          hoardMoney: [{ required: true, message: '可囤积金额必填', trigger: 'blur' }, { pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }],
          //isCutoutOfArrear: [{ required: true, message: '使能欠费跳闸必选', trigger: 'change' }]
        },
        isEdit: false,
      }
    },
    mounted() {
      this.fetchChargingPrice()
    },
    methods: {
      rowDelete: function(index, row) {
        this.meterConfigInfos = this.meterConfigInfos.slice()
      },
      rowSave: function(index, row) {
        row.isEdit = false
      },
      rowEdit: function(index, row) {
        this.$set(row, 'isEdit', true)
      },
      fetchChargingPrice: function () {//查询计费价格信息
        const condition = {customerId: this.customerId}
        getChargingByCustomerId(condition).then(res => {
          if(res.code === 200){
            this.chargingPrices =  res.infoJson
          }
        })
      },
      importFile: function (file) {
        /*const size = file.size
        if (size > 104857600) {
          this.$message('文件过大，上传限制100M')
          return
        }*/
        const length = file.name.split('.').length
        const types = file.name.split('.')[length-1]
        const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
        if (!fileType) {
          this.$message('格式错误！请重新选择')
          return
        }
        this.file2Xce(file).then(success => {
          if (success && success.length > 0) {
            let xlsxJson = success
            xlsxJson[0].sheet.splice(0,1)
            this.meterConfigInfos = xlsxJson[0].sheet
            /*this.meterConfigInfos.forEach(meterConfigInfo => {
              //meterConfigInfo.isEdit = false
              this.$set(meterConfigInfo, 'isEdit', false)
            })*/
            this.meterConfigDialogVisible = true
          }
        }, error => {
          if (!error) {
            this.$message('文件类型不正确！请重新选择')
          }
        })
      },
      /**
       * Excel文件解析json
       * @param file
       * @returns {Promise<unknown>}
       */
      file2Xce: function(file) {
        return new Promise(function(resolve, reject) {
          const reader = new FileReader()
          reader.onload = function(e) {
            try {
              const data = e.target.result
              this.wb = XLSX.read(data, {
                type: 'binary'
              })
              const result = []
              this.wb.SheetNames.forEach((sheetName) => {
                result.push({
                  sheetName: sheetName,
                  sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
                })
              })
              resolve(result)
            }catch (e) {
              reject(false)
            }
          }
          reader.readAsBinaryString(file.raw)
        })
      },
      objectSpanMethod: function({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          const _row = (this.getRowSpan().one)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row, //行
            colspan: _col //列
          }
        }
        if (columnIndex === 2) {
          const _row = (this.getRowSpan().two)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row, //行
            colspan: _col //列
          }
        }
        if (columnIndex === 3) {
          const _row = (this.getRowSpan().three)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row, //行
            colspan: _col //列
          }
        }
        if (columnIndex === 4) {
          const _row = (this.getRowSpan().four)[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row, //行
            colspan: _col //列
          }
        }

      },
      getRowSpan: function() {
        let spanOneArr = [],
          spanTwoArr = [],
          spanThreeArr = [],
          spanFourArr = [],
          concatOne = 0,
          concatTwo = 0,
          concatThree = 0,
          concatFour = 0;
        this.meterConfigInfos.forEach((item,index)=>{
          if(index === 0){
            spanOneArr.push(1);
            spanTwoArr.push(1);
            spanThreeArr.push(1);
            spanFourArr.push(1);
          }else{
            if(item.customerName === this.meterConfigInfos[index - 1].customerName){ //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            }else{
              spanOneArr.push(1);
              concatOne = index;
            };
            if(item.customerCode === this.meterConfigInfos[index - 1].customerCode){//第2列需合并相同内容的判断条件
              spanTwoArr[concatTwo] += 1;
              spanTwoArr.push(0);
            }else{
              spanTwoArr.push(1);
              concatTwo = index;
            };
            if(item.customerUserName === this.meterConfigInfos[index - 1].customerUserName){//第3列需合并相同内容的判断条件
              spanThreeArr[concatThree] += 1;
              spanThreeArr.push(0);
            }else{
              spanThreeArr.push(1);
              concatThree = index;
            };
            if(item.customerUserCode === this.meterConfigInfos[index - 1].customerUserCode){//第4列需合并相同内容的判断条件
              spanFourArr[concatFour] += 1;
              spanFourArr.push(0);
            }else{
              spanFourArr.push(1);
              concatFour = index;
            };
          }
        });
        return  {
          one: spanOneArr,
          two: spanTwoArr,
          three: spanThreeArr,
          four: spanFourArr
        }
      },
    }

  }
</script>
